import React, { createContext, useContext } from 'react';
var ThemeContext = createContext({ isDark: false, type: 'light' });
export var ThemeProvider = function (_a) {
    var children = _a.children, theme = _a.theme;
    return (React.createElement(ThemeContext.Provider, { value: theme }, children));
};
// eslint-disable-next-line no-underscore-dangle
var _isDark = function (props, theme) {
    var _a;
    if (props.dark === true) {
        return true;
    }
    if (props.light === true) {
        return false;
    }
    return (_a = theme.isDark) !== null && _a !== void 0 ? _a : false;
};
export var useTheme = function (props) {
    var providedTheme = useContext(ThemeContext);
    var isDark = _isDark(props, providedTheme);
    return { isDark: isDark, type: isDark ? 'dark' : 'light' };
};
